<!-- Identity Entity Dialog (mirrors AlertDataDialog styling: large kendo-dialog + full kendo-grid + Excel export). -->
@if (visible() && config(); as cfg) {
  <!-- No fixed height: the Dialog auto-sizes to the table, so a short list leaves no dead space
       below it. `maxHeight` caps it at the old fixed height, and the Dialog content scrolls once a
       tall table (or a large page size) would exceed that. Applies to both paging modes. -->
  <kendo-dialog
    (close)="onClose()"
    [width]="'95vw'"
    [maxHeight]="'90vh'"
    [minWidth]="'800px'"
    [maxWidth]="'1400px'"
  >
    <kendo-dialog-titlebar>{{ cfg.title }}</kendo-dialog-titlebar>

    @if (cfg.serverSide) {
      <!-- Server-side paging for unbounded lists: the shared grid asks for one page
           at a time instead of the dialog holding every row in memory. -->
      <app-datatable
        [data-href]="cfg.apiUrl"
        [columns]="datatableColumns()"
      ></app-datatable>
    } @else {
    <kendo-grid
      class="mxh-80v w-100"
      [data]="gridData()"
      [pageable]="{
        buttonCount: 5,
        info: true,
        type: 'numeric',
        pageSizes: [25, 50, 100, 200]
      }"
      [pageSize]="pageSize()"
      [skip]="skip()"
      [sortable]="true"
      [resizable]="true"
      [loading]="isLoading()"
      (pageChange)="onPageChange($event)"
    >
      <ng-template kendoGridToolbarTemplate>
        @if (cfg.subtitle) {
          <span class="text-muted small me-auto">{{ cfg.subtitle }}</span>
        }
        <button
          type="button"
          kendoGridExcelCommand
          class="cyflare-btn-secondary"
        >
          Export to Excel
        </button>
      </ng-template>

      @for (col of cfg.columns; track col.field) {
        <kendo-grid-column
          [field]="col.field"
          [title]="col.title"
          [width]="col.width ?? 160"
        >
          @if (col.type === 'date') {
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ (dataItem[col.field] | date: dateFormat) ?? col.emptyText ?? '' }}
            </ng-template>
          }
          @if (col.type === 'id') {
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="font-monospace small text-break">{{ dataItem[col.field] }}</span>
            </ng-template>
          }
          @if (col.type === 'badge') {
            <ng-template kendoGridCellTemplate let-dataItem>
              <span class="badge bg-light text-dark border">{{ dataItem[col.field] }}</span>
            </ng-template>
          }
          @if (col.type === 'boolean') {
            <ng-template kendoGridCellTemplate let-dataItem>
              <!-- aria-label because a bare glyph is unreadable to a screen reader, and these
                   columns are the substance of the row rather than decoration. -->
              <span
                class="cell-bool"
                [class.cell-bool--yes]="dataItem[col.field]"
                [attr.aria-label]="dataItem[col.field] ? 'Yes' : 'No'"
                [title]="dataItem[col.field] ? 'Yes' : 'No'"
                >{{ dataItem[col.field] ? '✓' : '✕' }}</span
              >
            </ng-template>
          }
        </kendo-grid-column>
      }

      <kendo-grid-excel [fileName]="exportFileName()" [fetchData]="allData"></kendo-grid-excel>
    </kendo-grid>
    }
  </kendo-dialog>
}
